// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bK6ci{display:flex;gap:16px;align-items:center}.LXqX7 label,.o0TxJ{block-size:100%;inline-size:100%;display:flex;align-items:center}.z4mbm{flex-shrink:0}.xuvCH{margin-inline-end:4px}.WY0Kh{display:flex;justify-content:space-between;width:100%;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `bK6ci`,
	"uploadPdfRow": `LXqX7`,
	"loadingRow": `o0TxJ`,
	"viewTosButton": `z4mbm`,
	"spinner": `xuvCH`,
	"menuItem": `WY0Kh`
};
export default ___CSS_LOADER_EXPORT___;
